<script setup lang="ts">
import type { IMenuItem } from "@/types"
import { toValue } from "vue"
import { Menu } from "@/components/legacy"
import { AppLink, Icon } from "@/components/ui"

defineProps<{
  item: IMenuItem
}>()
</script>

<template>
  <li v-if="!toValue(item.isHidden)" class="flex items-center">
    <div class="flex items-center">
      <Menu v-if="item.children" :items="item.children">
        <template #activator="{ toggle, isOpen }">
          <button
            class="flex gap-2 items-center whitespace-nowrap text-2xl md:text-sm font-montserrat font-bold md:font-medium no-underline hover:underline focus:underline"
            @click="toggle"
          >
            {{ item.label }}
            <Icon icon="CircleChevronDown" size="sm" class="transition ease-in-out" :class="{ 'rotate-180': isOpen }" />
          </button>
        </template>
      </Menu>
      <component
        :is="item.to ? AppLink : 'a'"
        v-else-if="item.href || item.to"
        :to="item.to"
        :href="item.href"
        class="whitespace-nowrap text-2xl md:text-sm font-montserrat font-bold md:font-medium no-underline hover:underline focus:underline cursor-pointer"
      >
        {{ item.label }}
      </component>
    </div>
  </li>
</template>
